// eslint-disable-next-line import/namespace
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cart: localStorage.getItem('cartItems') ? JSON.parse(localStorage.getItem('cartItems')) : [],
  isApiData: false
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { data, isApiData } = action.payload;
      const newItem = data;
      const updateCart = (data) => {
        const updatedData = data.map((item) => {
          if (item.projectGuID === newItem[0].projectGuID) {
            return { ...item, price: Math.floor(Math.random() * (100 - 50 + 1)) + 50 };
          }
          return item;
        });
        if (!isApiData) {
          localStorage.setItem('cart', JSON.stringify(updatedData));
        }
        state.cart = updatedData;
      };

      // Retrieve existing cart data or create an empty array
      const existingData = state.cart;

      // Check if item exists and update price if needed
      const itemExists = existingData.some((item) => item.projectGuID === newItem[0].projectGuID);
      if (itemExists) {
        updateCart(existingData);
      } else {
        updateCart([...existingData, ...newItem]);
      }
    },

    removeFromCart: (state, action) => {
      const { projectGuID, isApiData } = action.payload;

      // Remove item from cart based on projectGuID
      if (isApiData) {
        // Remove item from API data
        // Add logic to remove item from API data
        // For example:
        // API.delete(`/cart/${projectGuID}`);
      } else {
        // Remove item from local storage
        const updatedData = state.cart.filter((item) => item.projectGuID !== projectGuID);
        localStorage.setItem('cart', JSON.stringify(updatedData));
        state.cart = updatedData;
      }
    }
  }
});

export const { addToCart, removeFromCart } = cartSlice.actions;
export const selectCartItems = (state) => state.cart.cart;
export default cartSlice.reducer;
